import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import CustomField from '../Fields/CustomField.jsx';

const validate = values => {
  const errors = {};

  if (!values.token) {
    errors.token = 'required';
  }

  return errors;
};

@reduxForm({ form: 'WitcoActivationForm', validate })
class WitcoActivationForm extends React.Component {
  
  render() {
    return (
      <div>
        <Entity
          name="token"
          componentClass={Field}
          componentAttribute="placeholder"
          entity=""
          title="Witco API Key"
          component={CustomField}
        />
      </div>
    );
  }
} 

export default WitcoActivationForm;
